import { useEffect, useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";

import { api, ApiError } from "@/lib/api";
import { useSession } from "@/lib/auth";

/** 가드가 넘겨준 원래 목적지(없으면 종목 관리). */
interface FromState {
  from?: string;
}

export function LoginScreen() {
  const navigate = useNavigate();
  const location = useLocation();
  const session = useSession();

  const [username, setUsername] = useState("");
  const [password, setPassword] = useState("");
  const [submitting, setSubmitting] = useState(false);
  const [error, setError] = useState<string | null>(null);

  const from = (location.state as FromState | null)?.from ?? "/tickers";

  // 이미 로그인돼 있으면(직접 /login 진입, 다른 탭에서 로그인) 머무를 이유가 없다.
  useEffect(() => {
    if (session) navigate(from, { replace: true });
  }, [session, from, navigate]);

  const submit = async () => {
    if (!username.trim() || !password) {
      setError("아이디와 비밀번호를 입력하세요.");
      return;
    }
    setSubmitting(true);
    setError(null);
    try {
      await api.login(username.trim(), password);
      setPassword("");
      navigate(from, { replace: true });
    } catch (e) {
      // 429(시도 제한)·503(미설정)은 서버 메시지가 그대로 쓸모 있다.
      setError(
        e instanceof ApiError || e instanceof Error
          ? e.message
          : "로그인에 실패했습니다.",
      );
    } finally {
      setSubmitting(false);
    }
  };

  return (
    <div className="login">
      <form
        className="login-card"
        onSubmit={(e) => {
          e.preventDefault();
          void submit();
        }}
      >
        <h2 className="login-title">관리자 로그인</h2>
        <p className="login-sub">종목 등록·삭제는 관리자만 할 수 있습니다.</p>

        <input
          className="input"
          value={username}
          onChange={(e) => setUsername(e.target.value)}
          placeholder="아이디"
          autoComplete="username"
          autoCapitalize="none"
          autoCorrect="off"
          spellCheck={false}
          aria-label="아이디"
          disabled={submitting}
        />

        <input
          className="input"
          type="password"
          value={password}
          onChange={(e) => setPassword(e.target.value)}
          placeholder="비밀번호"
          autoComplete="current-password"
          aria-label="비밀번호"
          disabled={submitting}
        />

        {error && (
          <p className="error login-error" role="alert">
            {error}
          </p>
        )}

        <button className="btn" type="submit" disabled={submitting}>
          {submitting ? "로그인 중…" : "로그인"}
        </button>

        <p className="form-hint">
          신호·종목 <strong>조회</strong>는 로그인 없이 그대로 이용할 수 있습니다.
        </p>
      </form>
    </div>
  );
}
